/* eslint-disable @typescript-eslint/no-explicit-any */
import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import dayjs from "dayjs";
import { CalendarData, CalendarFinalResponseType } from "~/interface/calendar/calendar";
import { setSession } from "~/lib/helperFuncation/sessionStorageService";
import API_PATH from "~/utils/api-routes";
import { SELECTED_DATE, SELECTED_DATE_DATA } from "~/utils/constant";
import api from "~/utils/Interceptor";
export interface InitCalendarType {
  selectedDate: string;
  calendarData: CalendarData[];
  isLoading: boolean;
  selectedMonth: string;
  start_date: string;
  end_date: string;
}

// get calendar data
export const getCalendarData = createAsyncThunk<CalendarFinalResponseType, { start_date: string; end_date: string; lang?: string }>(
  "calendar/getCalendarData",
  async (params, { rejectWithValue }) => {
    const { lang = "en", ...dateParams } = params;
    const response = await api.get(API_PATH.NIRNAY, {
      params: { lang, ...dateParams },
    });
    return response.data;
  },
);

export const getAllEvent = createAsyncThunk<CalendarFinalResponseType, { start_date: string; end_date: string; lang?: string }>(
  "calendar/getAllEvent",
  async (params, { rejectWithValue }) => {
    const { lang = "en", ...dateParams } = params;
    const response = await api.get(API_PATH.NIRNAY, {
      params: { lang, ...dateParams },
    });
    return response.data;
  },
);

const initialState: InitCalendarType = {
  selectedDate: dayjs().format("YYYY-MM-DD"),
  calendarData: [],
  isLoading: false,
  selectedMonth: dayjs().format("YYYY-MM"),
  start_date: "",
  end_date: "",
};

// create a slice
export const calendarSlice = createSlice({
  name: "calendar",
  initialState,
  reducers: {
    // set selected date
    setSelectedDate: (state, action: PayloadAction<string>) => {
      state.selectedDate = action.payload;
      if (typeof window !== "undefined") {
        setSession(SELECTED_DATE, action.payload);
        const selectedDateData = state.calendarData.find((data) => data.date === action.payload);
        setSession(SELECTED_DATE_DATA, JSON.stringify(selectedDateData ?? null));
      }
    },
    setCalendarData: (state, action: PayloadAction<CalendarData[]>) => {
      state.calendarData = action.payload;
    },
    setSelectedMonth: (state, action: PayloadAction<string>) => {
      state.selectedMonth = action.payload;
    },
    setStartDate: (state, action: PayloadAction<string>) => {
      state.start_date = action.payload;
    },
    setEndDate: (state, action: PayloadAction<string>) => {
      state.end_date = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCalendarData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getCalendarData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.calendarData = action.payload.data.rows;
      })
      .addCase(getCalendarData.rejected, (state) => {
        state.isLoading = false;
      });
  },
});

export const { setSelectedDate, setCalendarData, setSelectedMonth, setStartDate, setEndDate } = calendarSlice.actions;
export default calendarSlice.reducer;
